import React, { useState } from "react";

/**
 * Image with graceful brutalist fallback.
 * Use everywhere instead of <img> when source is user-content / Unsplash placeholders.
 */
export default function SafeImage({ src, alt, className = "", fallbackLabel }) {
  const [failed, setFailed] = useState(false);

  if (!src || failed) {
    const label = fallbackLabel || alt || "Arre Sonora";
    return (
      <div
        className={`flex items-center justify-center bg-gradient-to-br from-arre-surface via-arre-black to-arre-red/20 ${className}`}
        data-testid="img-fallback"
      >
        <div className="text-center px-4">
          <div className="font-display text-arre-red text-5xl md:text-6xl mb-2 opacity-60">⟡</div>
          <div className="font-display text-white/70 text-xs md:text-sm tracking-[0.25em] uppercase line-clamp-2">
            {label}
          </div>
        </div>
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      onError={() => setFailed(true)}
      loading="lazy"
    />
  );
}
